<ng-container [ngTemplateOutlet]="autocompleteControlResult"
              [ngTemplateOutletContext]="$any({result: result})"></ng-container>
